import Layout from '../views/Layout';
import NotFound from '../views/NotFound';
// import Login from '../views/Login';
import Home from '../views/Website/home';
import Login from '../views/Website/login';
import { isUmebro } from '@/common/utils';

/**
 * 路由+菜单
 *
 * meta: {
 *  show: 是否导航展示；
 *  perm: 访问权限配置；// 若有子集，请直接设置子集perm;
 *  path: amis路径；若配置了path, 会拦截路由配置query: { _path }，并重定向到该amis页；
 * }
 */
const routers = [
	{
		path: '/',
		name: '首页',
		component: Home,
	},
	
	{
		path: '/flow',
		label: '流量',
		name: 'flow',
		icon: 'icon-flow',
		meta: {
			show: true,
			perm: (info) => {
				// return info.main_user <= 0
				return (info.qm_frontend_tabs_arr && info.qm_frontend_tabs_arr.media) 
				    || (info.qm_frontend_tabs_arr && info.qm_frontend_tabs_arr.adslot)
					|| (info.main_user <= 0)
			}
		},
		component: Layout,
		children: [
			{
				path: '/flow/applist',
				label: '应用管理',
				name: 'appList',
				meta: {
					show: true,
					perm: (info) => {
				        return info.qm_frontend_tabs_arr.media
						   || (info.main_user <= 0)
			        }
				},
				component: () => import('../views/FlowManagement/app'),
			},
			{
				path: '/flow/codelist',
				label: '代码位管理',
				name: 'codeList',
				meta: {
					show: true,
					perm: (info) => {
				        return info.qm_frontend_tabs_arr.adslot
					        || (info.main_user <= 0)
			        }
				},
				component: () => import('../views/FlowManagement/code'),
			},
			{
				path: '/flow/codeAdd',
				label: '代码位管理',
				name: 'codeAdd',
				meta: {
					show: false,
				},
				component: () => import('../views/FlowManagement/code/add.vue'),
			},
		],
	},
	{
		path:'/advCenter',
		label:'广告中心',
		name:'adCenter',
		icon:'icon-data',
		meta: {
			show: true,
			perm: (info) => {
				return (info.qm_frontend_tabs_arr && info.qm_frontend_tabs_arr.shield_rule)
				    || (info.main_user ? (info.only_review_auth) : (info.auth && info.auth.review_auth === 1))
					|| (info.main_user ? (info.only_preview_auth) : (info.auth && info.auth.preview_auth === 1))
					|| (info.main_user <= 0)
			}
		},
		component: Layout,
		children: [
			{
				path: '/advCenter/shield',
				label: '屏蔽规则',
				name: 'shield',
				meta: {
					show: true,
					perm: (info) => {
						// return info.main_user <= 0
						return info.qm_frontend_tabs_arr && info.qm_frontend_tabs_arr.shield_rule
					        || (info.main_user <= 0)
					}
				},
				component: () => import('../views/AdvCenter/shield')
			},
			{
				path: '/adCenter/review',
				label: '先投后审',
				name: 'review',
				meta: {
					show: true,
					perm: (info) => {
						return info.main_user ? (info.only_review_auth) : (info.auth && info.auth.review_auth === 1)
					}
				},
				component: () => import('../views/AdvCenter/review')
			},
			{
				path: '/adCenter/preview',
				label: '先审后投',
				name: 'preview',
				meta: {
					show: true,
					perm: (info) => {
						return info.main_user ? (info.only_preview_auth) : (info.auth && info.auth.preview_auth === 1)
					}
				},
				component: () => import('../views/AdvCenter/preview')
			}
		]
	},
	{
		path: '/data',
		label: '数据',
		name: 'data',
		icon: 'icon-data',
		meta: {
			show: true,
			perm: (info) => {
				// return info.main_user <= 0
				return info.qm_frontend_tabs_arr && info.qm_frontend_tabs_arr.report
				    || (info.main_user <= 0)
			}
		},
		component: Layout,
		children: [
			{
				path: '/data/dataList',
				label: '数据管理',
				name: 'dataList',
				meta: {
					show: true,
					perm: (info) => {
				        return info.qm_frontend_tabs_arr.report
						    || (info.main_user <= 0)
			        }
				},
				component: () => import('../views/DataManagement/data')
			},
			// {
			//   path: '/data/financeList',
			//   label: '财务结算',
			//   name: 'financeList',
			//   meta: {
			//     show: true
			//   },
			//   component: () => import('../views/DataManagement/finance')
			// },
		]
	},
	// {
	//   path: '/settlement',
	//   label: '结算',
	//   name: 'settlement',
	//   icon: 'icon-settlement',
	//   meta: {
	//     show: false
	//   },
	//   component: { render: (h) => h('router-view') },
	//   children: [{
	//     path: '/settlement/financeList',
	//     label: '财务结算',
	//     name: 'financeList',
	//     meta: {
	//       show: false
	//     },
	//     component: () => import('../views/SettlementManagement/finance')
	//   }]
	// },
	{
		path: '/access',
		label: '接入',
		name: 'access',
		icon: 'icon-access',
		meta: {
			show: !isUmebro(),
			perm: (info) => {
				// return info.main_user <= 0
				return (info.qm_frontend_tabs_arr && info.qm_frontend_tabs_arr.document) 
				    || (info.qm_frontend_tabs_arr && info.qm_frontend_tabs_arr.logo)
					|| (info.main_user <= 0)
			}
		},
		component: Layout,
		children: [
			{
				path: '/access/sdk',
				label: '对接文档',
				name: 'accessSdk',
				meta: {
					show: true,
					perm: (info) => {
				        return info.qm_frontend_tabs_arr.document
						    || (info.main_user <= 0)
			        }
				},
				component: () => import('../views/Access/sdk')
			},
			{
				path: '/access/adv',
				label: '广告标识',
				name: 'accessAdv',
				meta: {
					show: true,
					perm: (info) => {
				        return info.qm_frontend_tabs_arr.logo
						    || (info.main_user <= 0)
			        }
				},
				component: () => import('../views/Access/advSign')
			},
		]
	},
	{
		path: '/account',
		label: '账户',
		name: 'account',
		icon: 'icon-account',
		meta: {
			show: !isUmebro(),
			perm: (info) => {
				// return info.main_user <= 0
				return info.qm_frontend_tabs_arr && info.qm_frontend_tabs_arr.account_info
				    || (info.main_user <= 0)
			}
		},
		component: Layout,
		children: [
			{
				path: '/account/info',
				label: '账户信息',
				name: 'accountInfo',
				meta: {
					show: true,
					perm: (info) => {
				        return info.qm_frontend_tabs_arr.account_info
						    || (info.main_user <= 0)
			        }
				},
				component: () => import('../views/Account/info')
			}
		]
	},
	
  {
    path: '/logout',
    redirect: '/login',
  },
  {
    path: '/login',
    name: '登录',
    component: Login,
  },
  {
    path: '*',
    name: '404',
    component: NotFound,
  },
];

export default routers;
